import { bindable, children, autoinject, TaskQueue, computedFrom } from 'aurelia-framework';
import { IReportRowAM, IReportGroupRowAM } from './report-api';
import { ReportFinancialPrecision } from "./models/report-template";
import { convertFinancialPrecisionToDecimals } from "../../utils/report-utils";

@autoinject
export class ReportRowView {
	@bindable row: IReportRowAM;
	@bindable level = 0;
	@bindable precision: ReportFinancialPrecision;

	expanded: boolean;
	visibleRows: IReportRowAM[] = null;

	@children('report-row-view') childRows: ReportRowView[] = [];

	constructor(private taskQueue: TaskQueue) {
	}

	bind() {
		this.expanded = this.level === 0 ? true : false;
		
		if (this.expanded) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
		}
	}

	@computedFrom('precision')
	get numberOfDecimals(): number {
		return convertFinancialPrecisionToDecimals(this.row, this.precision)
	}

	toggleExpanded(): void {
		this.expanded = !this.expanded;
		if (this.expanded) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
		}
	}

	setExpandSelfAndChildren(expanded: boolean) {
		this.expanded = expanded;

		if (this.expanded && this.visibleRows == null) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
			this.taskQueue.queueTask(() => this.childRows.forEach(child => { child.setExpandSelfAndChildren(expanded); }));
		} else {
			this.childRows.forEach(child => { child.setExpandSelfAndChildren(expanded); });
		}
	}
}
